'use strict';

var React = require('react');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
require('./Cells/header.js');
require('./Cells/headerIcon.styles.js');
var cell = require('./Cells/cell.js');
require('./Cells/cellCheckbox.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('./Cells/cellSelect.styles.js');
require('../forms/Switch/component.js');
require('./Cells/cellSwitch.styles.js');
require('../Text/component.js');
require('./Cells/cellSubText.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('./Cells/cellPill.styles.js');
require('../Chip/component.js');
require('./Cells/cellChip.styles.js');
require('../Tag/component.js');
require('./Cells/cellTag.styles.js');
require('./Cells/cellActions.js');
require('./Cells/cellIcon.styles.js');
var row = require('./row.js');
var table_styles = require('./table.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const maxItems = (number, itemsPerPage) => (number > itemsPerPage ? itemsPerPage : number);
const LoadingState = ({ id, columns, skip, itemsPerPage, total, }) => {
    let remainingItemsCount = total - itemsPerPage * skip;
    if (skip && remainingItemsCount < 0) {
        console.warn('<LoadingState/> Fixing remainingItemsCount value automatically - you should use tableEngine methods in the correct order');
        remainingItemsCount = total;
    }
    const loadingItems = skip > 0 && total > 0 ? maxItems(remainingItemsCount, itemsPerPage) : itemsPerPage;
    return (React__default.default.createElement(React__default.default.Fragment, null, Array(loadingItems)
        .fill(0)
        .map((d, dataIndex) => (React__default.default.createElement(row.Row, { key: `${skip}-${dataIndex}`, id: `${id}-row-${dataIndex}` }, columns.map((c, colIndex) => (React__default.default.createElement(cell.Cell, { key: `${c.key}-${dataIndex}`, id: `${id}-cell-${dataIndex}-${colIndex}` },
        React__default.default.createElement(table_styles.FillingDiv, { style: { width: `${(Math.abs(Math.sin(dataIndex + colIndex)) * (1 - 0.25) + 0.25) * 100}%` } })))))))));
};
const EmptyState = ({ columns, labelEmptySub, labelEmptyTitle, isIconEmpty, isSmallEmpty, itemsPerPage, }) => {
    const regex = /([A-Z])\w+/;
    const regexExec = regex.exec(labelEmptyTitle);
    const firstWord = regexExec ? regexExec[0] : '';
    const mainRest = labelEmptyTitle.replace(firstWord, '');
    return (React__default.default.createElement(row.EmptyRow, { "$itemsPerPage": itemsPerPage },
        React__default.default.createElement(table_styles.EmptyCell, { colSpan: columns.length, "$itemsPerPage": itemsPerPage },
            React__default.default.createElement(table_styles.EmptyContainer, null,
                React__default.default.createElement(table_styles.IconEmptyContainer, null, isIconEmpty || React__default.default.createElement(component.Icon, { name: "empty-table-filled", size: "xl" })),
                !isSmallEmpty ? (React__default.default.createElement(React__default.default.Fragment, null,
                    React__default.default.createElement(table_styles.EmptyMainTextContainer, null,
                        React__default.default.createElement("span", null, firstWord),
                        mainRest),
                    React__default.default.createElement("div", null, labelEmptySub))) : null))));
};
const TableData = ({ engine, total, itemsPerPage, skip, columns, id, isIconEmpty, factoryHandleOnFocusRow, isSmallEmpty, getRowMode, labelEmptyTitle = 'Oops, aucun résultat ne correspond à votre recherche.', labelEmptySub = 'Nous vous invitons à effectuer une nouvelle recherche', expandedComponent, }) => {
    const getRowModeFn = React.useMemo(() => {
        if (getRowMode) {
            return getRowMode;
        }
        return () => 'default';
    }, [getRowMode]);
    if (engine.state.isLoading) {
        return React__default.default.createElement(LoadingState, { id: id, columns: columns, skip: skip, itemsPerPage: itemsPerPage, total: total });
    }
    if (engine.state.data.length === 0) {
        return (React__default.default.createElement(EmptyState, { columns: columns, isIconEmpty: isIconEmpty, itemsPerPage: itemsPerPage, labelEmptyTitle: labelEmptyTitle, labelEmptySub: labelEmptySub, isSmallEmpty: isSmallEmpty }));
    }
    return (React__default.default.createElement(React__default.default.Fragment, null, engine.state.data.map((d, dataIndex) => (React__default.default.createElement(row.Row, { key: d[engine.keyField], id: `${id}-row-${dataIndex}`, tabIndex: 0, onFocus: factoryHandleOnFocusRow(d), "$isFocus": engine.state.focusRow === d[engine.keyField], "$isEdit": engine.state.editingRows.includes(d[engine.keyField]), "$mode": getRowModeFn(d), data: d, columnsCount: columns.length, isExpanded: engine.state.expandedRows.includes(d[engine.keyField]), expandedComponent: expandedComponent }, columns.map((c, colIndex) => {
        if (c.field) {
            return (React__default.default.createElement(cell.Cell, { key: `${c.key}-${d[engine.keyField]}`, id: `${id}-cell-${dataIndex}-${colIndex}`, className: `ds-iziwork-col-${c.key}` }, d[c.field]));
        }
        if (c.cell) {
            const CellComponent = c.cell;
            return (React__default.default.createElement(CellComponent, { key: `${c.key}-${d[engine.keyField]}`, id: `${id}-cell-${dataIndex}-${colIndex}`, className: `ds-iziwork-col-${c.key}`, data: d }));
        }
    }))))));
};

exports.TableData = TableData;
//# sourceMappingURL=tableData.js.map
